import { Controller } from "@hotwired/stimulus"

// The onboarding wizard: a modal that cannot be dismissed. Continue unlocks
// once the step has a value. The time zone starts on the browser's, and the
// clock shows the time in the picked zone.
export default class extends Controller {
  static targets = ["form", "submit", "clock", "date", "themes"]

  connect() {
    this.reopen()
    this.pickBrowserZone()
    this.pickCurrentTheme()

    requestAnimationFrame(() => this.check())

    if (this.hasClockTarget) this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  reopen() {
    if (!this.element.open) this.element.showModal()
  }

  hold(event) {
    event.preventDefault()
  }

  check() {
    this.submitTarget.disabled = !new FormData(this.formTarget).get("value")

    if (this.hasClockTarget) this.tick()
  }

  tick() {
    const timeZone = this.zone
    const locale = document.documentElement.lang

    if (!timeZone) return

    this.clockTarget.textContent = new Intl.DateTimeFormat(locale, { timeZone, hour: "2-digit", minute: "2-digit", second: "2-digit" }).format()
    this.dateTarget.textContent = new Intl.DateTimeFormat(locale, { timeZone, dateStyle: "full" }).format()
  }

  get zone() {
    return new FormData(this.formTarget).get("value")
  }

  pickBrowserZone() {
    const dropdown = this.element.querySelector("[data-controller~=combobox]")

    if (!dropdown || this.zone) return

    const browser = Intl.DateTimeFormat().resolvedOptions().timeZone
    const known = JSON.parse(dropdown.dataset.comboboxItemsValue).some(item => item.value === browser)

    if (known) dropdown.dataset.comboboxSelectedValue = JSON.stringify([browser])
  }

  pickCurrentTheme() {
    if (!this.hasThemesTarget) return

    const theme = document.documentElement.dataset.theme
    const radio = this.themesTarget.querySelector(`input[value=${theme}]`)

    if (radio) radio.checked = true
  }
}
